module.exports = __webpack_public_path__ + "static/media/brackets-curly-solid.38880003.svg";